export default __webpack_public_path__ + "static/media/Belt of Infernal Zeal.d2cc742b.jpg";